<script setup lang="ts">
const cart = useCartStore()
import {useExtraScript} from "~/composables/useExtraScrtipts";

const startDate = computed(() => {
  const dates = cart.data?.items
    .map((item) => item.createdAt)
    .filter(Boolean)
    .map((date) => new Date(date as string).getTime())
    .filter(Boolean)

  if (!dates?.length) return

  return new Date(Math.min(...dates))
})

const endDate = computed(() => {
  const dates = cart.data?.items
    .map((item) => item.expiresAt)
    .filter(Boolean)
    .map((date) => (date as number) * 1000)

  if (!dates?.length) return

  return new Date(Math.min(...dates))
})

const headData = useExtraScript();
useHead(headData)
</script>

<template>
  <div class="app-layout">
    <AppNavbar logo-only>
      <template v-if="startDate && endDate" #timer>
        <AppNavbarTimer
          :start-date="startDate"
          :end-date="endDate"
          @expired="cart.refreshGetters"
        />
      </template>
    </AppNavbar>

    <div class="mb-auto">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-layout {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 100vh;
  // `clip` prevents horizontal overflow like `hidden` did, but without creating
  // a scroll container — `overflow: hidden` here disabled `position: sticky`
  // for everything inside (e.g. the hotel results map).
  overflow-x: clip;
}
</style>
